import React from "react";
import { Navigate } from "react-router-dom";
import AuthCard from "../layout/AuthCard";
import useAuthPageRedirect from "../../hooks/useAuthPageRedirect";

const AuthPageShell = ({ children }) => {
  const { user, loading, redirectTo } = useAuthPageRedirect();

  if (loading) {
    return (
      <section className="flex min-h-[calc(100dvh-10rem)] items-center justify-center bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
        <div
          className="h-9 w-9 animate-spin rounded-full border-2 border-amber-400/30 border-t-amber-400"
          aria-label="Loading"
        />
      </section>
    );
  }

  if (user) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <section className="relative flex min-h-[calc(100dvh-10rem)] items-center justify-center overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 px-4 py-10 sm:py-14">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(251,191,36,0.06)_0%,transparent_50%)]" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_80%_100%,rgba(251,191,36,0.03)_0%,transparent_40%)]" />

      <div className="relative z-10 w-full max-w-md">
        <AuthCard>{children}</AuthCard>
      </div>
    </section>
  );
};

export default AuthPageShell;
